// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { ErrorInformationStorage } from '../Commons/ErrorInformationStorage';
import { Rectangle } from '../Commons/Geometry';
import { TerceraChartRendererDrawingAdvancedParamsEnum, TerceraChartToolRendererDrawingType } from './Utils/ChartConstants';
import { TerceraChartUtils } from './TerceraChartUtils';
import { type TerceraChartBaseRenderer } from './Renderers/TerceraChartBaseRenderer';

export class TerceraChartWindow {
    public PaddingRenderers = [];// new List<TerceraChartBaseRenderer>();
    public RendPaddingTop = 0;
    public RendPaddingBottom = 0;
    public RendPaddingLeft = 0;
    public RendPaddingRight = 0;

    // #region Properties

    public AutoScalePaddPixel = 20;

    /// <summary>
    /// если в контейнере несколоько окон - надо ли им рисовать хэдеры с коллапсерос и для ресайза   хз!
    /// </summary>
    public HeaderVisible = false;
    /// <summary>
    /// у главного окна немного другое поведение завел флаг
    /// </summary>
    public IsMainWindow;

    public HeaderHeight = 21;

    /// <summary>
    ///
    /// </summary>
    public PaddingLeft = 0;
    public PaddingTop = 0;
    public PaddingRight = 40;
    public PaddingBottom = 0;

    /// <summary>
    /// Индекс крайнего правого отображаемого бара
    /// </summary>
    public i1 = 0;

    /// <summary>
    /// Масштаб по оси X (px на 1 бар)
    /// </summary>
    public XScale = 25;// 4;

    /// <summary>
    /// Масшатб по оси Y
    /// </summary>
    public YScale;

    /// <summary>
    /// Количество баров, помещающихся в текущий размер окна
    /// с текущим масштабом (XScale)
    /// </summary>

    /// <summary>
    /// Мин/Макс по шкале Y
    /// </summary>
    public FminFloatY = 0;
    public FmaxFloatY = 0;

    public autoscaleMinDelta = 1;
    public autoscaleMaxDelta = 1;

    public Rectangle = new Rectangle();

    /// <summary>
    /// Список MainThread рендереров связанных с окном, ТОЛЬКО РИСОВАНИЕ В ГЛАВНОМ ПОТОКЕ
    /// </summary>
    public MainThreadRenderers: TerceraChartBaseRenderer[] = [];
    /// <summary>
    /// Список рендереров связанных с окном, ТОЛЬКО БЭКГРАУНД РИСОВАНИЕ
    /// </summary>
    public Renderers: TerceraChartBaseRenderer[] = [];

    public indicatorRendererSettings = { UseInAutoscale: true };

    public Collapsed = false;

    // без паддингов, паддинги учитываются в виндоу контейнере
    public HeightKoef = 100;

    public AutoScale = true;

    public needRecalcAutoscale = false;
    /// <summary>
    /// Всегда отображать последние бары
    /// </summary>
    public StickToEnd = true;

    public PriceScaleRenderer;
    public LeftPriceScaleRenderer;

    public ToolsRenderer;

    public PointsConverter;

    public IndicatorStorageRenderer;

    public SCALE_LIMIT = 100000000;

    public WindowsContainer = null;

    public ClientRectangle = new Rectangle();

    // #endregion
    public prevScaleW = 0;
    public previousYScale: any;
    public TerceraChartOverlayWindow: boolean;
    // #region zoom

    private zoomType = TerceraChartWindowZoomType.Common;

    // #endregion

    constructor (PriceScaleRenderer, ToolsRenderer, leftPriceScaleRenderer) {
        this.PriceScaleRenderer = PriceScaleRenderer;
        if (PriceScaleRenderer !== null && PriceScaleRenderer !== undefined) {
            this.Renderers.push(PriceScaleRenderer);
        }

        this.LeftPriceScaleRenderer = leftPriceScaleRenderer;
        if (leftPriceScaleRenderer !== null && leftPriceScaleRenderer !== undefined) {
            this.Renderers.push(this.LeftPriceScaleRenderer);
        }

        this.ToolsRenderer = ToolsRenderer;
        if (ToolsRenderer !== null && ToolsRenderer !== undefined) {
            this.ToolsRenderer.InstanceWindow = this;
            this.Renderers.push(this.ToolsRenderer);
        }
    }

    public GetWindowHeaderRectangle (WindowHeaderRectangle, collapserRectangle) {
        if (this.HeaderVisible) {
            WindowHeaderRectangle = new Rectangle(
                this.Rectangle.X + (this.PaddingLeft > 0 ? this.PaddingLeft - 1 : 0),
                this.Rectangle.Y,
                this.ClientRectangle.Width + 1,
                this.HeaderHeight);

            // ГЛАВНОЕ НЕЛЬЗЯ КОЛЛАПСИТЬ
            if (!this.IsMainWindow) {
                collapserRectangle = new Rectangle(WindowHeaderRectangle.X + WindowHeaderRectangle.Width - 16, WindowHeaderRectangle.Y, 16, this.HeaderHeight);
            } else {
                collapserRectangle = Rectangle.Empty();
            }
        } else {
            WindowHeaderRectangle = collapserRectangle = Rectangle.Empty();
        }

        return { WindowHeaderRectangle, collapserRectangle };
    }

    public GetAllRenderers (): TerceraChartBaseRenderer[] {
        return this.MainThreadRenderers.concat(this.Renderers);
    }

    public im (): number {
        return this.ClientRectangle.Width / this.XScale;
    }

    public UpdateClientRectangle (): void {
        this.ClientRectangle.X = this.Rectangle.X + this.PaddingLeft + this.RendPaddingLeft;
        this.ClientRectangle.Y = this.Rectangle.Y + this.PaddingTop + this.RendPaddingTop;
        this.ClientRectangle.Width = this.Rectangle.Width - this.PaddingLeft - this.PaddingRight - this.RendPaddingLeft - this.RendPaddingRight;
        this.ClientRectangle.Height = this.Rectangle.Height - this.PaddingTop - this.PaddingBottom - this.RendPaddingTop - this.RendPaddingBottom;
    }

    /// <summary>
    /// Расчёты выполняемы перед прорисовкой окнв
    /// </summary>
    public BeforeDrawing (advParams = null): void {
        this.CalcScales();

        // Сбрасываем параметр на дефолт
        const par = advParams;
        if (par != null) {
            // to think
            this.OnLayout(par.LayoutInfo);

            par.Tag[TerceraChartRendererDrawingAdvancedParamsEnum.CurrentDrawingType] = TerceraChartToolRendererDrawingType.Background;
            // каждое окно рисует само
            // par.DrawPointers.Clear();
        }
    }

    public CalcScales (): boolean {
        if (this.FmaxFloatY === this.FminFloatY) {
            this.YScale = 0;
        } else {
            this.YScale = this.ClientRectangle.Height / (this.FmaxFloatY - this.FminFloatY);
            if (this.previousYScale !== this.YScale) {
                this.previousYScale = this.YScale;
                return true;
            }
        }
    }

    /// <summary>
    ///
    /// </summary>
    public CalculateMinMax (): void {
        try {
            if (!this.AutoScale && !this.needRecalcAutoscale) {
                return;
            }

            if (this.needRecalcAutoscale) {
                this.needRecalcAutoscale = false;
            }

            let newFminFloatY = Number.MAX_VALUE;
            let newFmaxFloatY = -Number.MAX_VALUE;

            const tMin = Number.MAX_VALUE;
            const tMax = -Number.MAX_VALUE;

            const rendLen = this.Renderers.length;
            for (let i = 0; i < rendLen; i++) {
                const refObj: any = {};
                refObj.tMin = tMin;
                refObj.tMax = tMax;

                if (this.Renderers[i].UseInAutoscale && this.Renderers[i].FindMinMax(refObj, this)) {
                    if (refObj.tMin < newFminFloatY) {
                        newFminFloatY = refObj.tMin;
                    }

                    if (refObj.tMax > newFmaxFloatY) {
                        newFmaxFloatY = refObj.tMax;
                    }
                }
            }

            if (newFminFloatY === Number.MAX_VALUE && newFmaxFloatY === -Number.MAX_VALUE) {
                // Никто не дал мин/макс - оставляем предыдущее значения
                // (пример: скрытие всех линий индикатора на дополнительно окне)
            } else {
                // Женя: если так совпало что мин и макс одинаковы... чтоб не было на шкале вечного нуля
                if (newFminFloatY === newFmaxFloatY) {
                    newFminFloatY -= this.autoscaleMinDelta;
                    newFmaxFloatY += this.autoscaleMaxDelta;
                }

                //
                // Add small padding for autoscale
                // pixels convert to price and change Min/Max
                if (newFminFloatY !== newFmaxFloatY) {
                    const minMaxDelta = Math.abs(newFmaxFloatY - newFminFloatY);
                    const clientH = this.ClientRectangle.Height;
                    const scalePadding = clientH && minMaxDelta
                        ? this.AutoScalePaddPixel / (clientH / minMaxDelta)
                        : 1;

                    newFminFloatY -= scalePadding;
                    newFmaxFloatY += scalePadding;
                }

                // replace values
                this.FminFloatY = newFminFloatY;
                this.FmaxFloatY = newFmaxFloatY;
            }
        } catch (ex) {
            ErrorInformationStorage.GetException(ex);
            // Utils.log(ex);
        }
    }

    public AutoFit (): void {
        this.needRecalcAutoscale = true;
    }

    /// <summary>
    ///
    /// </summary>
    public Draw (gr, windowsContainer, advParams = null): void {
        this.BeforeDrawing(advParams);

        // First draw container renderes
        let i;
        const curLayer = advParams.layerId;
        const len = this.Renderers.length;
        for (i = 0; i < len; i++) {
            const curRend = this.Renderers[i];
            // TODO. Move "!this.Collapsed" out from the loop.
            if (!this.Collapsed || curRend.plateRenderer || curRend.priceScaleRenderer) {
                if (curRend.IsNeedDraw(curLayer)) {
                    curRend.Draw(gr, this, windowsContainer, advParams);
                }
            }
        }

        const par = advParams;
        if (par) {
            const drawPointers = par.DrawPointers;
            // drawPointers.Sort(new DrawPointerComparer());

            const len = drawPointers.length;
            for (let i = 0; i < len; i++) {
                const pointer = drawPointers[i];
                TerceraChartUtils.DrawPointer(gr, this, pointer.priceValue, pointer.backgroundBrush, pointer.formatPriceValue, pointer.Font, pointer.borderPen, pointer.StringFormat, pointer.yLocation);
            }

            drawPointers.splice(0, len);
        }
    }

    /// <summary>
    ///
    /// </summary>
    public OnLayout (info = null): void {
        //    //
        //    // надо рендерить плашки индюков и оверлеев?
        //    //

        const plateRenderer = this.GetMainThreadRenderer('TerceraChartPlateRenderer');

        if ((plateRenderer != null && !plateRenderer.IsEmpty()) || this.TerceraChartOverlayWindow) // this instanceof TerceraChartOverlayWindow медленный добавил флаг. сравнить на его присутствие намного быстрее, где нет this.TerceraChartOverlayWindow=undefined
        {
            this.HeaderVisible = true;
            this.PaddingTop = this.HeaderHeight + 1;
        } else {
            this.PaddingTop = 0;
            this.HeaderVisible = false;
        }

        this.PaddingRight = info == null ? this.prevScaleW : info.PreferredWidthScales;

        if (info != null) {
            this.PaddingLeft = info.PreferredWidthScalesLeft;
        }

        this.UpdateClientRectangle();

        const clientR = this.ClientRectangle;
        if (this.PriceScaleRenderer) {
            this.PriceScaleRenderer.Rectangle = new Rectangle(
                clientR.X + clientR.Width,
                clientR.Y - this.PaddingTop,
                this.PaddingRight,
                clientR.Height + this.PaddingTop);
        }

        if (this.LeftPriceScaleRenderer != null && info != null) {
            if (this.IsMainWindow) {
                //
                // Показываем левую шкалу только, когда нет оверлеев но есть задвоенные индюки
                // (Если есть оверлеи - они показывают шкалу, поэтому встроенная не нужна)
                //
                if (!info.HasOverlays && info.HasDoubledIndicator) {
                    this.LeftPriceScaleRenderer.Visible = true;
                    this.LeftPriceScaleRenderer.Rectangle = new Rectangle(0, clientR.Y - this.PaddingTop, info.PreferredWidthScalesLeft, clientR.Height + this.PaddingTop);
                } else {
                    this.LeftPriceScaleRenderer.Visible = false;
                }
            } else {
                if (info.HasDoubledIndicator || info.HasOverlays) {
                    this.LeftPriceScaleRenderer.Visible = true;
                    this.LeftPriceScaleRenderer.Rectangle = new Rectangle(0, clientR.Y - this.PaddingTop, info.PreferredWidthScalesLeft, clientR.Height + this.PaddingTop);
                } else {
                    this.LeftPriceScaleRenderer.Visible = false;
                }
            }
        }

        if (plateRenderer != null && !plateRenderer.IsEmpty()) // обновляем ректангл, для всех окон место на коллапсер, разделитель рисуется в виндоу контейнере
        {
            let headerRect = new Rectangle();
            let collapserRect = new Rectangle();

            const res = this.GetWindowHeaderRectangle(headerRect, collapserRect);

            headerRect = res.WindowHeaderRectangle;
            collapserRect = res.collapserRectangle;

            plateRenderer.Rectangle = new Rectangle(headerRect.X + 1, headerRect.Y, headerRect.Width - collapserRect.Width - 1, this.HeaderHeight);
        }

        this.LayoutPaddingRenderers();

        if (info != null) {
            this.prevScaleW = info.PreferredWidthScales;
        }
    }

    public LayoutPaddingRenderers (): void {
        if (this.PaddingRenderers.length == 0) {
            return;
        }

        this.RendPaddingTop = 0;
        this.RendPaddingBottom = 0;
        this.RendPaddingLeft = 0;
        this.RendPaddingRight = 0;

        const clientRect = this.ClientRectangle;
        // var leftRenderer = TerceraChartWindowDockableContainer.LayoutRenderers(clientRect, PaddingRenderers);

        this.RendPaddingTop += clientRect.Top();// - leftRenderer.Top;
        this.RendPaddingBottom += clientRect.Bottom(); // - leftRenderer.Bottom;
        this.RendPaddingLeft += clientRect.Left(); // - leftRenderer.Left;
        this.RendPaddingRight += clientRect.Right(); // - leftRenderer.Right;
    };

    // public prevScaleW;

    /// <summary>
    ///
    /// </summary>
    // public virtual ContextMenuStrip GetContextMenu(MouseEventArgs e, TerceraChartBase chart)
    // {
    //    ContextMenuStrip contextMenu = null;

    // foreach (var renderer in GetAllRenderers)
    // {
    //    contextMenu = renderer.GetContextMenu(e, chart);
    //    if (contextMenu != null)
    //        return contextMenu;
    // }

    // return contextMenu;
    // }

    public Dispose (): void {
        this.indicatorRendererSettings = null;
        this.WindowsContainer = null;
        this.PriceScaleRenderer = null;
        this.LeftPriceScaleRenderer = null;

        for (let i = 0; i < this.Renderers.length; i++) {
            this.Renderers[i].Dispose();
        }

        this.Renderers = [];
        this.MainThreadRenderers = [];
        this.PaddingRenderers = [];
    }

    /// <summary>
    ///
    /// </summary>
    public ThemeChanged (applyToTable): void {
        const renderers = this.Renderers;
        const len = renderers.length;
        for (let i = 0; i < len; i++) {
            renderers[i].ThemeChanged(applyToTable);
        }
    }

    public Localize (): void {
        const renderers = this.Renderers;
        const len = renderers.length;
        for (let i = 0; i < len; i++) {
            renderers[i].Localize();
        }
    }

    /// <summary>
    ///
    /// </summary>
    // public List<T> GetRenderers<T>()
    // where T : TerceraChartBaseRenderer
    // {
    // return Renderers.Where(x => x.GetType() == typeof(T)).Cast<T>().ToList();
    // }

    // public T GetRenderer<T>()
    // where T : TerceraChartBaseRenderer
    // {
    //    return (T)Renderers.FirstOrDefault(x => x.GetType() == typeof(T));
    // }

    public GetRenderer (T): any {
        const res = null;
        const arr = this.Renderers;

        let i;
        const len = arr.length;
        for (i = 0; i < len; i++) {
            if ((arr[i] instanceof T)) {
                return arr[i];
            }
        }

        return res;
    }

    // TODO. Replace this.Renderers with main thread renderers.
    // parameter is name of Class
    public GetMainThreadRenderer (T): any {
        const res = null;
        const arr = this.Renderers;

        let i;
        const len = arr.length;
        for (i = 0; i < len; i++)
        // ищем по флагу имени класса, который не забываем добавит рендереру!!!
        {
            if ((arr[i].ClassNameStorage[T])) {
                return arr[i];
            }
        }

        return res;
    }

    // #region Zoom

    /// <summary>
    /// ТОЛЬКО ГЕТ. для установки SetZoomType(TerceraChartWindowZoomType newType, TimeFrameInfo tfi)
    /// </summary>
    public ZoomType (): TerceraChartWindowZoomType {
        return this.zoomType;
    }

    public SetZoomType (tfi, font): void {
        // определяем тип
        const newType = TerceraChartWindowZoomType.Common;
        // specific scales
        // if (tfi != null && tfi.TradeAnalysisType == TradeAnalysisType.Cluster)
        //    newType = TerceraChartWindowZoomType.Cluster;
        // else if (tfi != null && tfi.TradeAnalysisType == TradeAnalysisType.MarketProfile)
        //    newType = TerceraChartWindowZoomType.MarketProfile;
        // else
        //    newType = TerceraChartWindowZoomType.Common;

        // обновляем значения
        // if (newType == TerceraChartWindowZoomType.MarketProfile) // ! надо пересчитать константы !
        // {
        //    List<var > profileZoomValuesNew = new List<var >();
        //    var  minZoom = 100;
        //    try
        //    {
        //        Graphics gr = BaseApplication.App.MainGUIInvoker.CreateGraphics();
        //        var aggregation = (com.pfsoft.proftrading.cash.TFAggregationModeMarketProfile)tfi.AggregationMode;
        //        var  period = tfi.Period;
        //        var  subPeriod = TFInfo.GetRealPeriodValue(aggregation.buildFromPeriod, aggregation.buildFromPeriodValue);
        //        var  a = period < 0 && subPeriod == 0 ? -period : (var )Math.Ceiling(period / (var )subPeriod);
        //        StringBuilder text = new StringBuilder();

        //        for (var i = 0; i < a; i++)
        //        {
        //            text.Append(TerceraChartCashItemSeries.ProfileGetLetter(i));
        //        }
        //        text.Append('>');

        //        minZoom = (var )Math.Ceiling(gr.MeasureString(text.ToString(), font).Width);
        //    }
        //    catch { }

        //    for (var i = 0; i < ZOOM_VALUES.Count; i++)
        //        profileZoomValuesNew.Add(minZoom + i * 5);

        //    profileZoomValues = profileZoomValuesNew;
        // }

        //  устанавливаем тип
        // Convert xscale by index
        // if (zoomType != newType)
        // {
        let currentIndex = this.ActiveZoomLevels().indexOf(this.XScale);

        this.zoomType = newType;

        if (currentIndex == -1) {
            currentIndex = this.ActiveZoomLevels().indexOf(this.XScale);
        }

        if (currentIndex == -1) {
            currentIndex = 0;
        }

        if (currentIndex < this.ActiveZoomLevels.length) {
            this.CheckAndSetXScale(this.ActiveZoomLevels()[currentIndex]);
        }
        // }
    }

    public ActiveZoomLevels (): number[] {
        /// / specific scales
        // if ( zoomType == TerceraChartWindowZoomType.Cluster)
        //    return CLUSTER_ZOOM_VALUES;
        // else if ( zoomType == TerceraChartWindowZoomType.MarketProfile)
        //    return PROFILE_ZOOM_VALUES;
        // else
        return TerceraChartWindow.ZOOM_VALUES;
    }

    /// <summary>
    ///
    /// </summary>
    public ZoomIn (): void {
        let scaleIndex = this.ActiveZoomLevels().indexOf(this.XScale);
        scaleIndex++;
        if (scaleIndex < this.ActiveZoomLevels().length) {
            this.CheckAndSetXScale(this.ActiveZoomLevels()[scaleIndex]);
        }
    }

    public ZoomOut (): void {
        let scaleIndex = this.ActiveZoomLevels().indexOf(this.XScale);
        scaleIndex--;
        if (scaleIndex >= 0) {
            this.CheckAndSetXScale(this.ActiveZoomLevels()[scaleIndex]);
        }
    }

    public static readonly ZOOM_VALUES = [1, 2, 3, 4, 6, 8, 12, 16, 25, 50, 100, 200];
    // static List<var > CLUSTER_ZOOM_VALUES = new List<var >(new var [] { 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120, 125 });
    /// * instance - пересчёт на смену ZoomType( а он в свою очередь на TF, и callback) */
    // List<var > PROFILE_ZOOM_VALUES { get { return profileZoomValues; } }
    // List<var > profileZoomValues = new List<var >(12);

    /// <summary>
    ///
    /// </summary>
    public CheckAndSetXScale (newXScale: number): void {
        // max
        if (newXScale > this.ActiveZoomLevels()[this.ActiveZoomLevels().length - 1]) {
            newXScale = this.ActiveZoomLevels()[this.ActiveZoomLevels().length - 1];
        }

        // min
        if (newXScale < this.ActiveZoomLevels()[0]) {
            newXScale = this.ActiveZoomLevels()[0];
        }

        // Allow values only from ZOOM_VALUES
        if (!this.ActiveZoomLevels().includes(newXScale)) {
            let minIndex = 0;
            let minDelta = Math.abs(this.ActiveZoomLevels()[0] - newXScale);
            for (let i = 1; i < this.ActiveZoomLevels().length; i++) {
                if (Math.abs(this.ActiveZoomLevels()[i] - newXScale) < minDelta) {
                    minDelta = Math.abs(this.ActiveZoomLevels()[i] - newXScale);
                    minIndex = i;
                }
            }
            newXScale = this.ActiveZoomLevels()[minIndex];
        }

        this.XScale = newXScale;
    }

    public CanZoomIn (): boolean {
        return this.XScale < this.ActiveZoomLevels()[this.ActiveZoomLevels().length - 1];
    }

    public CanZoomOut (): boolean {
        return this.XScale > this.ActiveZoomLevels()[0];
    }

    public ZoomAll (): void {
        this.CheckAndSetXScale(this.ActiveZoomLevels()[0]);
    }

    public GetScaleMultiply (): number {
        return 1;
    }

    // #endregion

    // public virtual bool IsContainX(TerceraChartBaseSeries serie, var  i)
    // {
    // return ((i1 - im) < i ) && (i <= i1);
    // }

    /// // <summary>
    /// //   // check value
    /// // </summary>
    public SetMinMaxScale (newFmaxFloatY: number, newFminFloatY: number, converter): void {
        if (converter) {
            converter = null;
        }

        if (Math.abs(newFmaxFloatY) < this.SCALE_LIMIT && Math.abs(newFminFloatY) < this.SCALE_LIMIT) {
            // Кейс: шкала log, значения в серии маленькие, но так для рисовании шкалы нужны абсолютные значения,
            // возможен выход за допустимые пределы. Пришлось прокидывать сюда конвертер
            // todo: достаточно проверки newFmaxFloatY ???
            if (converter != null && (Math.abs(converter.Revert(newFmaxFloatY)) > this.SCALE_LIMIT || Math.abs(converter.Revert(newFminFloatY)) > this.SCALE_LIMIT)) {
                return;
            }

            this.FmaxFloatY = newFmaxFloatY;
            this.FminFloatY = newFminFloatY;
            this.CalcScales();
        }
    }
}

// #region IWindow Members

// Rectangle IWindow.WindowRectangle
// {
//    get { return ClientRectangle; }
// }

// var  IWindow.HighestPrice
// {
//    get { return FmaxFloatY; }
// }

// var  IWindow.LowestPrice
// {
//    get { return FminFloatY; }
// }

// bool IWindow.IsMainWindow
// {
//    get {return IsMainWindow; }
// }

// var  IWindow.WindowNumber
// {
//    get { return WindowsContainer != null ? WindowsContainer.Windows.IndexOf(this) : -1; }
// }

// #endregion

enum TerceraChartWindowZoomType {
    Common = 0,
    Cluster = 1,
    MarketProfile = 2
};

export class TerceraChartOverlayWindow extends TerceraChartWindow {
    public Overlay: any = null;
    public TerceraChartOverlayWindow = true;

    public Dispose (): void {
        this.Overlay = null;

        super.Dispose();
    }

    public OnLayout (info = null): void {
        super.OnLayout(info);

        if (this.LeftPriceScaleRenderer != null && info != null) {
        //
        // Показываем шкалу для активного оверлея
        //
            if (this.Overlay.chart.ActiveOverlayGet() == this.Overlay && this.Overlay.separateScale) {
                const clientR = this.ClientRectangle;

                this.LeftPriceScaleRenderer.Visible = true;
                this.LeftPriceScaleRenderer.Rectangle = new Rectangle(0, clientR.Y - this.PaddingTop, info.PreferredWidthScalesLeft, clientR.Height + this.PaddingTop);
            } else {
                this.LeftPriceScaleRenderer.Visible = false;
            }
        }
    }

    public ThemeChanged (applyToTable): void {
        super.ThemeChanged(applyToTable);

        this.Overlay.ThemeChanged(applyToTable);
    }
}
